import { Carousel, Spin } from '@douyinfe/semi-ui';
import { useBanner } from '@/hooks/useBanner';
import Y from '@/assets/3.jpg';
import Z from '@/assets/4.jpg';
import { reportClickBanner } from '@/report';
import { useScope } from '@/hooks/useScope';
import { Scope } from '@/typings/fe';

const ScopeMap: Record<Scope, string[]> = {
  other: [Z],
  synthesize: [Y, Z],
  merchant: [Z],
  'mini-app': [Y, Z],
  'mini-game': [Y, Z],
};

export const Banners = () => {
  const { banners, loading } = useBanner();
  const scope = useScope();

  if (loading) {
    return (
      <div
        className="flex items-center  justify-center "
        style={{
          width: '100%',
          height: '288px',
          borderRadius: '12px',
        }}>
        <Spin />
      </div>
    );
  }
  return (
    <div className="center">
      {
        <Carousel
          theme="dark"
          style={{
            width: '100%',
            height: '288px',
            borderRadius: '12px',
          }}>
          {banners.length > 0
            ? banners.map((banner, index) => (
                <div
                  onClick={() => {
                    reportClickBanner({
                      banner_id: banner.Id,
                      pic_link: banner.Image,
                      post_link: banner.Url,
                      label: banner.Label,
                      serial: banner.Serial,
                      post_title: banner.Title,
                    });
                    window.open(banner.Url);
                    // history.push(banner.Url);
                  }}
                  key={index}
                  style={{
                    backgroundSize: 'cover',
                    backgroundImage: `url(${banner.Image})`,
                    cursor: 'pointer',
                  }}></div>
              ))
            : ScopeMap[scope].map((banner, index) => (
                <img src={banner} key={index} alt={'Banner图'}></img>
              ))}
        </Carousel>
      }
    </div>
  );
};
